import React from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import * as firebaseui from "firebaseui";
import { Card } from "@KristianIV/common-ui";
import Brand from "../shell/Brand";
import StyledFirebaseAuth from "./StyledFirebaseAuth";
import styles from "./LoginPage.module.css";

const uiConfig: firebaseui.auth.Config = {
  callbacks: {
    // Avoid redirects after sign-in.
    signInSuccessWithAuthResult: () => false,
  },
  // Need to use popup because of this:
  // https://github.com/firebase/firebase-js-sdk/issues/6716
  signInFlow: "popup",
  signInOptions: [
    {
      provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
      disableSignUp: { status: true },
    },
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  ],
};

/** Shown while Firebase Auth has no user. FirebaseUI runs the sign-in itself; the page only frames it. */
const LoginPage = () => (
  <div className={styles.page}>
    <div className={styles.column}>
      <Brand />
      <Card interactive={false} padded className={styles.card}>
        <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} className={styles.auth} />
      </Card>
    </div>
  </div>
);

export default LoginPage;
